module.exports = __webpack_public_path__ + "static/img/wechat.1d7db4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/wechat.png
// module id = 0jFG
// module chunks = 8